<template>
  <div :class="[...sizeVariant, 'spinner']"></div>
</template>

<script>
  export default {
    name: 'BaseLoader',

    props: {
      size: {
        type: String,
        default: 'xs',
        validator: (v) => {
          return ['xs', 'sm', 'md', 'lg', 'xl', '2xl', '3xl'].indexOf(v) !== -1;
        },
      },
    },

    computed: {
      sizeVariant() {
        const variants = {
          xs: ['w-3', 'h-3', 'border-2'],
          sm: ['w-4', 'h-4', 'border-2'],
          md: ['w-5', 'h-5', 'border-2'],
          lg: ['w-6', 'h-6', 'border-2'],
          xl: ['w-8', 'h-8', 'border-2'],
          '2xl': ['w-10', 'h-10', 'border-2'],
          '3xl': ['w-12', 'h-12', 'border-2'],
        };

        return variants[this.size];
      },
    },
  };
</script>

<style scoped>
  .spinner {
    display: inline-block;
    vertical-align: text-bottom;
    border-right-color: transparent;
    border-radius: 50%;
    -webkit-animation: spinner 0.75s linear infinite;
    animation: spinner 0.75s linear infinite;
  }

  @keyframes spinner {
    to {
      transform: rotate(360deg);
    }
  }
</style>
